/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { UserForOrganizationAdminRequest } from '../../models/user-for-organization-admin-request';

export interface PostAdministrationOrganizationUserV3$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
      body: UserForOrganizationAdminRequest
}

export function postAdministrationOrganizationUserV3(http: HttpClient, rootUrl: string, params: PostAdministrationOrganizationUserV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postAdministrationOrganizationUserV3.PATH, 'post');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postAdministrationOrganizationUserV3.PATH = '/administration/organizations/{organizationKey}/users';
